import { render, staticRenderFns } from "./SafeAccounts.vue?vue&type=template&id=16c70132&"
import script from "./SafeAccounts.vue?vue&type=script&lang=js&"
export * from "./SafeAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports